import React from 'react';
import { Heart, MapPin, Phone, Instagram, Facebook, MessageCircle } from 'lucide-react';
import { Link } from 'react-router-dom';
import { businessInfo } from '../mock';

const WHATSAPP_NUMBER = '33640486009';
const PHONE_NUMBER = '+33640486009';
const WHATSAPP_LINK = 'https://wa.me/33640486009?text=Bonjour%2C%20je%20souhaite%20prendre%20rendez-vous%20%F0%9F%92%85';

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white pb-28 md:pb-8">
      <div className="container mx-auto px-4 py-10 md:py-12">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* Marque */}
          <div>
            <h3 className="text-2xl md:text-3xl font-bold mb-3 brand-font" style={{ color: '#E8A8C8' }}>
              {businessInfo.name}
            </h3>
            <p className="text-gray-400 mb-4 text-sm md:text-base">
              Prothésiste ongulaire à domicile à La Réunion
            </p>
            <div className="flex gap-3">
              <a
                href="https://www.instagram.com/nail.edbychloe/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center transition-colors"
                style={{ ':hover': { backgroundColor: '#D1477A' } }}
                onMouseEnter={(e) => e.target.style.backgroundColor = '#D1477A'}
                onMouseLeave={(e) => e.target.style.backgroundColor = ''}
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=61584927464807"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 rounded-full flex items-center justify-center transition-colors"
                onMouseEnter={(e) => e.target.style.backgroundColor = '#D1477A'}
                onMouseLeave={(e) => e.target.style.backgroundColor = ''}
                aria-label="Facebook"
              >
                <Facebook size={20} />
              </a>
              <a
                href={WHATSAPP_LINK}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-white/10 hover:bg-green-500 rounded-full flex items-center justify-center transition-colors"
                aria-label="WhatsApp"
              >
                <MessageCircle size={20} />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-base md:text-lg font-semibold mb-4">Navigation</h4>
            <ul className="space-y-2">
              {[
                { id: 'hero', label: 'Accueil' },
                { id: 'services', label: 'Services & Tarifs' },
                { id: 'gallery', label: 'Galerie' },
                { id: 'reviews', label: 'Avis' },
                { id: 'contact', label: 'Contact' },
              ].map((item) => (
                <li key={item.id}>
                  <button
                    onClick={() => scrollToSection(item.id)}
                    className="text-gray-400 hover:text-rose-400 transition-colors text-sm md:text-base"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-base md:text-lg font-semibold mb-4">Contact</h4>
            <ul className="space-y-3">
              <li>
                <a
                  href="https://maps.google.com/?q=Ravine+des+Cabris+La+Reunion"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-start gap-2 text-gray-400 hover:text-rose-400 transition-colors text-sm md:text-base"
                >
                  <MapPin size={18} className="flex-shrink-0 mt-0.5" />
                  <span>Ravine des Cabris, La Réunion</span>
                </a>
              </li>
              <li>
                <a
                  href={`tel:${PHONE_NUMBER}`}
                  className="flex items-start gap-2 text-gray-400 hover:text-rose-400 transition-colors text-sm md:text-base"
                >
                  <Phone size={18} className="flex-shrink-0 mt-0.5" />
                  <span>Sur rendez-vous</span>
                </a>
              </li>
              <li className="text-gray-400 text-sm md:text-base">
                <strong style={{ color: '#E8A8C8' }}>Lun-Sam</strong> • 8h-18h
              </li>
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-800 pt-6">
          <div className="flex flex-col sm:flex-row justify-between items-center gap-3 text-sm text-gray-500">
            <div className="flex flex-col sm:flex-row items-center gap-2 sm:gap-4">
              <p>© {currentYear} {businessInfo.name}. Tous droits réservés.</p>
              <Link 
                to="/mentions-legales" 
                className="text-gray-500 hover:text-rose-400 transition-colors text-xs sm:text-sm"
              >
                Mentions légales & CGV
              </Link>
            </div>
            <p className="flex items-center gap-1">
              Fait avec <Heart style={{ color: '#E8A8C8' }} size={14} fill="currentColor" /> à La Réunion
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};
